import { render, staticRenderFns } from "./LicenseForm.vue?vue&type=template&id=88a8c8f0"
import script from "./LicenseForm.vue?vue&type=script&lang=js"
export * from "./LicenseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports